import { LogError } from "../../../helpers/logger"
import { getEnvironmentCode } from "../developerToolsHelpers"

export const activityTrackingSettingNames = {
  logoutTimeout: "AT_logoutTimeout",
  warningDuration: "AT_warningDuration",
}
export const settingsList = [
  {
    name: activityTrackingSettingNames.logoutTimeout,
    description:
      "Duration (in minutes) of inactivity before user is logged out",
    defaultSetting: 60,
  },
  {
    name: activityTrackingSettingNames.warningDuration,
    description: "Duration (in seconds) of warning before user is logged out",
    defaultSetting: 30,
  },
]

export const getSettingOverrideValue = (key) => {
  const defaultOverrideValue = {
    overrideValue: undefined,
  }

  try {
    const storageValue = localStorage.getItem(key)

    if (storageValue) {
      let overrideValue = JSON.parse(storageValue)

      return overrideValue
    } else {
      return defaultOverrideValue
    }
  } catch (error) {
    LogError(
      "Unable to retrieve override setting value from localStorage",
      error,
    )
    return defaultOverrideValue
  }
}

export const setSettingOverrideValue = (key, value) => {
  if (value === "") {
    localStorage.removeItem(key)
  } else {
    const saveValue = JSON.stringify({ overrideValue: value })

    localStorage.setItem(key, saveValue)
  }
}

export const hasActiveActivityTrackerOverrides = () => {
  const environmentCode = getEnvironmentCode()
  let hasActive = false

  settingsList.forEach((setting) => {
    if (!hasActive) {
      const override = getSettingOverrideValue(
        `${setting.name}${environmentCode}`,
      )
      if (override?.overrideValue) {
        hasActive = true
      }
    }
  })

  return hasActive
}
